import React from 'react';
import Modal from 'components/Modal';
import Form from 'components/ReportABugModal/Form';
import { StyledLongBody } from 'components/ChangePassewordModal/styles';
import { get } from 'lodash';
import { translate } from 'helpers/intl';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'components/ReportABugModal/messages';

const ReportABugModal = (props: ReportAbugModalType) => {
  const { isOpen, handleClose } = props;
  return (
    <Modal
      open={isOpen}
      handleClose={handleClose}
      header={
        <StyledLongBody weight="500" color="#04336B">
          {translate(get(messages, 'title'), props)}
        </StyledLongBody>
      }
      content={
        <Form
          reportABug={props.reportABug}
          handleClose={handleClose}
          isLoading={props.isLoading}
        />
      }
    />
  );
};

export interface ReportAbugModalType {
  isOpen: boolean;
  intl: IntlShape;
  handleClose: Function;
  reportABug: Function;
  isLoading: boolean;
}

export default injectIntl(ReportABugModal);
